import { ReactNode } from "react";

import GlobeIcon from "@atlaskit/icon/core/globe";
import {
    JiraIcon,
    ConfluenceIcon,
    BitbucketIcon,
    JiraServiceManagementIcon
} from "@atlaskit/logo";
import { Box, xcss } from "@atlaskit/primitives-next";

export const ICON_COMPONENT_MAP = {
    jira: {
        products: ["jira", "jira software", "advanced roadmaps", "jira core"],
        source: <JiraIcon appearance="brand" size="small" />,
        destination: <JiraIcon appearance="inverse" size="small" />
    },
    confluence: {
        products: ["confluence"],
        source: <ConfluenceIcon appearance="brand" size="small" />,
        destination: <ConfluenceIcon appearance="inverse" size="small" />
    },
    bitbucket: {
        products: ["bitbucket"],
        source: <BitbucketIcon appearance="brand" size="small" />,
        destination: <BitbucketIcon appearance="inverse" size="small" />
    },
    jiraServiceManagement: {
        products: ["jira service management"],
        source: <JiraServiceManagementIcon appearance="brand" size="small" />,
        destination: <JiraIcon appearance="inverse" size="small" />
    }
};

type IconMap = Record<
    string,
    {
        products: string[];
        source: React.ReactNode;
        destination: React.ReactNode;
    }
>;

type GetProductIconUtilArgs = {
    iconMap: IconMap;
    productType: string;
    type: "source" | "destination";
};

const customLinkIconStyles = xcss({
    width: "30px",
    height: "30px",
    borderRadius: "border.radius.200",
    borderColor: "color.border",
    borderStyle: "solid",
    color: "color.text.accent.gray.bolder",
    backgroundColor: "color.background.accent.gray.subtler",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

// To make this testable, extracted map logic to separate function
export const getProductIconUtil = ({
    iconMap,
    productType,
    type
}: GetProductIconUtilArgs): ReactNode | null => {
    const lowerProductType = productType.toLowerCase();

    const iconFamily = Object.values(iconMap).find(({ products }) =>
        products.includes(lowerProductType)
    );

    if (!iconFamily) {
        return (
            <Box xcss={customLinkIconStyles} testId="custom-link-icon">
                <GlobeIcon label="custom link" />
            </Box>
        );
    }

    return iconFamily[type];
};

export const getProductIcon = ({
    productType,
    type
}: Omit<GetProductIconUtilArgs, "iconMap">) =>
    getProductIconUtil({ iconMap: ICON_COMPONENT_MAP, productType, type });
